import { type Locale, format, isValid, parseISO } from 'date-fns';

import {
  ProviderDetailsResource,
  ProviderLinkResource,
} from '@provider-directory/types/providers.contracts';

// The section and its table-of-contents anchor both derive visibility from this
// selector, so the flag is gated here rather than at each call site — the anchor
// can never point at a section the flag suppressed.
export const getProviderLinks = (
  provider: ProviderDetailsResource,
  isProviderLinksEnabled: boolean,
): ProviderLinkResource[] => {
  if (!isProviderLinksEnabled) {
    return [];
  }

  return [...(provider.links ?? [])].sort((a, b) => a.order - b.order);
};

export const getLinkDisplayName = (link: ProviderLinkResource): string => {
  const displayName = link.displayName?.trim();

  return displayName || new URL(link.url).hostname;
};

// Accepts both "YYYY-MM" and full "YYYY-MM-DD" — the backend sends day
// precision, but the caption only ever shows month and year.
const formatLinkDate = (date: string, locale?: Locale): string => {
  const parsed = parseISO(date);

  return isValid(parsed) ? format(parsed, 'MMM yyyy', { locale }) : date;
};

export const formatLinkCaption = (
  link: ProviderLinkResource,
  locale?: Locale,
): string | null => {
  const parts = [
    link.mediaType?.trim(),
    link.source?.trim(),
    link.date?.trim() ? formatLinkDate(link.date.trim(), locale) : undefined,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(' • ') : null;
};
